import { getPaymentMethodsClient } from '@b-stock/fe-core/bstock-next/queries'
import { buildAxiosRequestConfig } from '@b-stock/fe-core/bstock-react'

const setPaymentMethodDefault = (id: string, accessToken: string) => {
  const paymethodsClient = getPaymentMethodsClient()

  return paymethodsClient.makeMethodPrimary(
    { id },
    buildAxiosRequestConfig({ accessToken })
  )
}

export default setPaymentMethodDefault
